import React from 'react';
import { Link as StyleguideLink } from 'styleguide';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import { Resolver } from 'craft/types';

export const Link: Resolver = ({ element, attributes, children }: any) => {
  const className = toCssSelector('link', {
    variant: { variant: 'base' },
    output: 'html',
  });

  return (
    <StyleguideLink
      {...attributes}
      className={className}
      href={element?.data?.props?.href ?? '#'}
      onClick={(e: Event) => {
        e.preventDefault();
      }}
    >
      {children}
    </StyleguideLink>
  );
};
